var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "entryDesign" }, [
    _c("div", { staticClass: "formTitle" }, [_vm._v("作品信息")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "designInfo" },
      _vm._l(_vm.infoList, function (i, j) {
        return _c(
          "div",
          { key: j, staticClass: "infoItem" },
          [
            _c("span", { staticClass: "labelSpan" }, [
              _vm._v(_vm._s(i.label) + "："),
            ]),
            _vm._v(" "),
            _c("el-tooltip", { attrs: { placement: "top" } }, [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(_vm._s(i.value)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "valSpan" }, [_vm._v(_vm._s(i.value))]),
            ]),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "formTitle" }, [_vm._v("作品")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "entryWorksWarp" },
      _vm._l(_vm.entryList, function (i, j) {
        return _c(
          "div",
          { key: j, staticClass: "entryItem" },
          [
            _c("span", { staticClass: "labelSpan" }, [
              _vm._v(_vm._s(i.label) + "："),
            ]),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "entryWorks" },
              [
                i.type === "img"
                  ? [
                      _c("el-image", {
                        attrs: { src: i.src, "preview-src-list": [i.src] },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                i.type === "video"
                  ? [_c("video", { attrs: { controls: "", src: i.src } })]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "downLoadBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-download",
                      size: "mini",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.downLoadWorks(i.url)
                      },
                    },
                  },
                  [_vm._v("\n          下载\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }